<template>
    <div class="w-100" :style="publicStyle">
        <div class="bar-item d-flex align-items-center justify-content-center w-100" v-for="entry of data"
             :key="entry.label">
            <div class="label" v-if="hasHTML" v-html="entry.label"></div>
            <div class="label" v-if="!hasHTML">{{ entry.label | removeUnderscoreAndCapitalize }}</div>
            <div class="bar d-flex align-items-center" v-if="showBars">
                <div class="text-data"
                     style="min-width: 60px"
                     v-if="entry.average &gt; 0"># {{ entry.data }}
                </div>
                <progress-bar class="mr-2"
                                  v-if="entry.data"
                                  :color="colorOf(entry)"
                                  :value="100"
                                  style="margin-top: 1px; max-width: 280px"
                                  :style="{flexBasis: percentage(entry.data) + '%'}"/>
                <div class="text-data"
                     style="min-width: 20px"
                     v-if="entry.average &gt; 0">
                    <i class="fa fa-star ml-2"
                       style="color: #0069d1"
                       v-if="entry.average &gt; 0">
                    </i>
                    {{ entry.average | showAverage() }}
                </div>
                <div class="text-data"
                     v-if="!entry.average &gt; 0">{{ entry.data }} {{ entry.average | showAverage }}
                </div>
            </div>
            <div class="percentage" v-if="showPercentages" :class="{'ml-auto': showBars, 'pl-3': showBars}"></div>
        </div>
        <span class="legend small" v-if="!hasHTML &amp;&amp; hasAverage"># Total reviews&nbsp;/
    <i class="fa fa-star ml-1 mr-1" style="color: #0069d1;"></i>Avg Score (0-5)
    </span>
    </div>
</template>

<style lang="sass" scoped>
    .legend
        position: absolute
        bottom: 30px
        right: 20px
    .bar-item
        margin-top: 1rem
        margin-bottom: 1rem

        .label
            margin-right: 0.75rem
            text-align: right
            font-weight: bold

        .percentage
            min-width: 65px !important
            text-align: left
            font-weight: bold

        .bar
            width: 70%
            .text-data
                color: grey
                word-wrap: normal
                flex-shrink: 0
</style>


<script>
    export default {
        props: {
            type           : {default: null},
            data           : {required: true, type: Array},
            showBars       : {default: true},
            showPercentages: {default: true},
            defaultColor   : {default: "#0374d7"},
            colors         : {
                default: () => [
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8",
                    "#0374d8"
                ]
            }
        },

        computed: {
            numbers() {
                return this.data.map(d => d.data);
            },

            total() {
                return _.sum(this.numbers);
            },

            hasHTML() {
                return this.data[0].label.includes("<span>");
            },

            hasAverage() {
                return this.data[0].hasOwnProperty('average');
            },

            publicStyle() {
                if (this.type == 'public') {
                    return 'line-height: 1; margin-top:-20px;';
                }
                return;
            }

        },

        filters: {
            removeUnderscoreAndCapitalize: function (value) {
                if (value === "software_advice")
                    return value.replace("software_advice", "Advice");
                return value.charAt(0).toUpperCase() + value.slice(1);
            },

            showAverage(average) {
                return average > 0 ? `${average}` : "";
            }
        },

        updated() {
            this.normalizeLabelWidths();
        },

        mounted() {
            this.normalizeLabelWidths();
        },

        methods: {
            percentage(number) {
                if (number === 0) return 0;
                const rounded = _.round(number * 100 / this.total);
                return rounded === 0 && number > 0 ? 1 : rounded;
            },

            normalizeLabelWidths() {
                const labels = $(this.$el).find(".label");
                const widths = labels.map(function () {
                    return $(this).width();
                });

                const maxWidth = _.max(widths);
                labels.each(function () {
                    this.style.minWidth = maxWidth + 1 + "px";
                });
            },

            colorOf(entry) {
                return (
                    entry.color ||
                    this.colors[this.data.indexOf(entry)] ||
                    this.defaultColor
                );
            }
        }
    };
</script>
